import HubspotAPI, { ObjectType } from "./HubspotAPI";
export default class NotesManager extends HubspotAPI {
    constructor() {
        super();
    }
    async createNote(title, ticketId, dbNoteId, note, userEmail, robotSerialNumber) {
        const lowerCaseEmail = userEmail.toLowerCase();
        const bodyData = {
            properties: {
                hs_note_body: HubspotAPI.compileContent(title, note, dbNoteId, lowerCaseEmail, robotSerialNumber, "note"),
                hs_timestamp: await HubspotAPI.getLondonTime(),
            },
            associations: [
                {
                    to: {
                        id: ticketId,
                    },
                    types: [
                        {
                            associationCategory: "HUBSPOT_DEFINED",
                            associationTypeId: 228
                        }
                    ]
                }
            ]
        };
        const response = await this.sendRequest("POST", '', bodyData, ObjectType.NOTES);
        if (response && response.data && response.data.id) {
            return response.data.id;
        }
        return null;
    }
    async getNote(noteId, email) {
        const lowerCaseEmail = email.toLowerCase();
        const bodyData = {
            email: lowerCaseEmail
        };
        const response = await this.sendRequest("GET", noteId + "?properties=hs_note_body", bodyData, ObjectType.NOTES);
        return (response === null || response === void 0 ? void 0 : response.data) || null;
    }
    async deleteNote(noteId) {
        const response = await this.sendRequest("DELETE", noteId, {}, ObjectType.NOTES);
        if (!response)
            return false;
        if (response.data && response.data.status && response.data.status === 'error') {
            return false;
        }
        return true;
    }
}
